module.exports = __webpack_public_path__ + "img/money@3x.d4586fad.png";